import { axios } from '@Root/API'

export const edit = (engagementId, payload) => {
	return axios.put(`student-engagement/${engagementId}/accreditation-aim/${payload.id}`, payload)
}
